import { defineStore } from 'pinia';
import ShippingReturnReason from '../../settings/entities/shipping-return-reason';
import OrdersService from '../service';

export const useRefundOrderDialogStore = defineStore('refundOrderDialog', {
	state: () => ({
		isOpen: false,
		products: [],
		otoShippingFee: 0,
		loading: false,
		orderReturn: null,
	}),
	getters: {
		totalAmount(state) {
			return Math.max(
				0,
					state.otoShippingFee +
					state.products.reduce((val, product) => {
						return val + (+product.refundAmount || 0);
					}, 0),
			);
		},
	},
	actions: {
		async fetchReturnReasons() {
			const { data } = await ShippingReturnReason.getReasons({ per_page: 100 });
			this.returnReasons = data;
		},
		async fetchShippingCompanies() {
			this.shippingCompanies = [];
			this.shippingCompaniesLoading = true;
			try {
				const data = await OrdersService.getDeliveryCompanies({
					customer_id: this.selectedOrder.customer_id,
					weight: this.selectedOrder.total_weight,
					pickup_location_id: this.pickupLocation,
				});
				this.shippingCompanies = data;
			} finally {
				this.shippingCompaniesLoading = false;
			}
		},
		async refundOrder() {
			this.loading = true;
			try {
				const res = await this.orderReturn.refundOrder(this.totalAmount);
				return res;
			} finally {
				this.loading = false;
			}
		},
		openDialog(orderReturn) {
			this.orderReturn = orderReturn;
			this.products = orderReturn.products.filter((product) => product.accept_status == "1")
            .map((product) => ({
				...product,
				refundAmount: +product.total,
			}));
			this.otoShippingFee = +orderReturn.shipping_fee || 0;
			this.isOpen = true;
		},
		resetData() {
			this.isOpen = false;
			this.loading = false;
			this.orderReturn = null;
			this.products = [];
		},
	},
});
